// Interfaces
import { IBaseApi, IBaseApiRequest } from 'interfaces/api'

// Axios
import { axios } from 'utils'

// Axios
import { AxiosRequestConfig } from 'axios'

export abstract class BaseApi<T extends IBaseApi> implements IBaseApiRequest {
  abstract url: T['url']

  /**
   * @description GET Request
   *
   * @param {string} url
   * @param {any} requestOptions
   *
   * @return {Promise<any>} Promise<any>
   */
  GET(url: string, requestOptions?: AxiosRequestConfig): Promise<any> {
    return axios.get(url, {
      ...requestOptions,
    })
  }

  /**
   * @description POST Request
   *
   * @param {string} url
   * @param {any} data
   * @param {any} requestOptions
   *
   * @return {Promise<any>} Promise<any>
   */
  POST(url: string, data: T['data'], requestOptions?: AxiosRequestConfig): Promise<any> {
    return axios.post(url, data, requestOptions)
  }

  /**
   * @description PUT Request
   *
   * @param {string} url
   * @param {any} data
   * @param {any} requestOptions
   *
   * @return {Promise<any>} Promise<any>
   */
  PUT(url: string, data: T['data'], requestOptions?: AxiosRequestConfig): Promise<any> {
    return axios.put(
      url,
      { ...data },
      {
        ...requestOptions,
      },
    )
  }

  /**
   * @description DELETE Request
   *
   * @param {string} url
   * @param {any} requestOptions
   *
   * @return {Promise<any>} Promise<any>
   */
  DELETE(url: string, requestOptions?: AxiosRequestConfig): Promise<any> {
    return axios.delete(url, {
      ...requestOptions,
    })
  }
}
